import { render, staticRenderFns } from "./tmOverlayBorder.vue?vue&type=template&id=33317fcb&"
import script from "./tmOverlayBorder.vue?vue&type=script&lang=js&"
export * from "./tmOverlayBorder.vue?vue&type=script&lang=js&"
import style0 from "./tmOverlayBorder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports